import { $, _, Backbone } from "js/vendor";
import { Key } from "js/core/utilities/keys";
import { PlayerThumbnailView } from "js/player/playerThumbnailView";
import SlideItem from "js/editor/components/slideItemView";

const isElectron = navigator.userAgent.includes("Electron/");
const isMSWindows = navigator.userAgent.includes("Windows NT");

export const PlayerPresenterView = Backbone.View.extend({
    className: "player-presenter",

    events: {
        keydown: "onKeyDown"
    },

    initialize: function(options) {
        this.player = options.player;
        this.playableSlides = this.getPlayableSlides();

        this.listenTo(this.player, "play", event => {
            this.renderCurrentSlide(event.index);
        });

        // MS Windows only
        if (isElectron && isMSWindows) {
            document.addEventListener("leave-full-screen", event => {
                this.renderWindowStateIcon("maximize");
            });

            document.addEventListener("enter-full-screen", event => {
                this.renderWindowStateIcon("restore");
            });
        }
    },

    // MS Windows only
    renderWindowStateIcon(action) {
        this.$windowStateIcon.removeClass("restore");
        this.$windowStateIcon.removeClass("maximize");
        this.$windowStateIcon.addClass(action);
        const title = { "restore": "Restore", "maximize": "Maximize" }[action];
        this.$windowStateIcon.prop("title", title);

        // show/hide the "swap" button
        if (this.$swapIcon) {
            if (action == "restore") {
                this.$swapIcon.show();
            } else {
                this.$swapIcon.hide();
            }
        }
    },

    render: function() {
        if (isElectron) {
            this.$header = this.$el.addEl($.div("header"));
            let $headerRight = this.$header.addEl($.div("header-right"));

            // MS Windows-specific CSS
            if (isMSWindows) {
                $headerRight.addClass("ms-windows");
            }

            // switch button only shown on windows, or mac with multiple displays
            if (isMSWindows || window.electronDisplays > 1) {
                this.$swapIcon = $.icon("swap_horiz", "header-btn");
                $headerRight.addEl(this.$swapIcon).click(event => {
                    event.stopPropagation();
                    this.player.switchDisplays();
                }).prop("title", "Switch displays");
            }

            this.$windowStateIcon = $(`<i class="header-btn svg-icon restore" title="Restore"></i>`);

            // MS Windows only
            if (isMSWindows) {
                $headerRight.addEl($.icon("minimize", "header-btn")).click(event => {
                    event.stopPropagation();
                    this.player.minimizePresenter();
                }).prop("title", "Minimize");

                $headerRight.addEl(this.$windowStateIcon).click(event => {
                    event.stopPropagation();
                    this.player.togglePresenterFullScreen();
                }).prop("title", "Restore");
            }

            $headerRight.addEl($.icon("close", "header-btn")).click(event => {
                event.stopPropagation();
                this.player.closePlayer();
            }).prop("title", "Exit the presentation");
        }

        let $main = this.$el.addEl($.div("main-frame"));

        let $currentSlide = $main.addEl($.div("current-slide"));

        this.$currentSlideThumbnail = $currentSlide.addEl(
            $.div("slide-thumbnail")
        );
        this.$currentSlideThumbnail.on("click", event => {
            event.stopPropagation();
            this.player.goNextSlide(true);
        });

        let $controlBar = $currentSlide.addEl($.div("control-bar"));

        let $leftSpacer = $controlBar.addEl($.div("left-spacer"));
        this.$clock = $leftSpacer.addEl($.div("clock"));

        setInterval(() => {
            this.$clock.text(new Date().toString("hh:mm:ss tt"));
        }, 1000);

        $controlBar.addEl($.icon("navigate_before", "navigate-btn")).click(event => {
            event.stopPropagation();
            this.player.goPrevSlide(true);
        });

        this.$slideCount = $controlBar.addEl($.div("slide_count", ""));

        $controlBar.addEl($.icon("navigate_next", "navigate-btn")).click(event => {
            event.stopPropagation();
            this.player.goNextSlide(true);
        });

        let $rightSpacer = $controlBar.addEl($.div("right-spacer"));
        this.$slideTimer = $rightSpacer.addEl($.div("timer"));
        $rightSpacer.addEl($.div("", "/"));
        this.$totalTimer = $rightSpacer.addEl($.div("timer"));
        this.$totalTimer.text("00:00:00");

        this.totalSeconds = 0;
        this.slideSeconds = 0;
        this.totalTimer = setInterval(() => {
            this.$totalTimer.text(
                new Date(1000 * this.totalSeconds).toISOString().substr(11, 8)
            );
            this.$slideTimer.text(
                new Date(1000 * this.slideSeconds).toISOString().substr(11, 8)
            );
            this.totalSeconds++;
            this.slideSeconds++;
        }, 1000);

        this.$notes = $main.addEl($.div("notes"));

        this.$slideList = this.$el.addEl($.div("slide-list"));
        this.renderSlides();

        this.renderCurrentSlide(this.player.currentSlideIndex);

        $(window).on("keydown", event => this.onKeyDown(event));

        return this;
    },

    onKeyDown: function(event) {
        switch (event.which) {
            case Key.LEFT_ARROW:
            case Key.UP_ARROW:
            case Key.PAGE_UP:
                this.player.goPrevSlide(true);
                break;
            case Key.RIGHT_ARROW:
            case Key.DOWN_ARROW:
            case Key.PAGE_DOWN:
                this.player.goNextSlide(true);
                break;
            case Key.ESCAPE:
                this.player.closePlayer();
                break;
        }
    },

    renderCurrentSlide: function(index) {
        let slide = this.player.slides[index];
        slide.model.load().then(() => {
            this.$currentSlideThumbnail.empty();
            let currentSlide = new SlideItem({
                model: slide.model,
                slideIndex: this.player.slides.indexOf(slide),
                player: this.player,
                thumbnailSize: "large"
            });
            this.$currentSlideThumbnail.append(currentSlide.render().$el);

            this.$notes.empty();
            if (slide.model.get("slide_notes")) {
                let $text = this.$notes.addEl($("<span></span>"));
                $text.html(slide.model.get("slide_notes"));

                let fontSize = 28;

                do {
                    $text.css("font-size", fontSize);
                    fontSize -= 2;
                } while (
                    $text.height() > this.$notes.height() &&
                    fontSize >= 16
                );
            } else {
                this.$notes.addEl(
                    $("<span style='font-style: italic'>No notes</span>")
                );
            }

            this.updateSlideInfo();

            this.$slideList.find(".selected").removeClass("selected");
            this.$slideList
                .find(".slide-thumbnail:eq(" + index + ")")
                .addClass("selected");

            let scroll = 200 * index - window.innerWidth / 2 + 200;
            $(".slide-list").scrollLeft(scroll);
            // if (scroll > 0) {
            //     $(".slide-list").animate({
            //         scrollLeft: scroll
            //     });
            // }

            this.startTimer();
        });
    },

    displayCurrentSlideIndex: function() {
        let currentSlideIndex = 0;
        for (let i = 0; i < this.player.currentSlideIndex; i++) {
            let slide = this.player.slides[i];
            if (!slide.model.get("isSkipped")) {
                currentSlideIndex++;
            }
        }
        return currentSlideIndex;
    },

    getPlayableSlides: function() {
        let playableSlides = [];
        this.player.slides.forEach(slide => {
            if (!slide.model.get("isSkipped")) {
                playableSlides.push(slide);
            }
        });
        return playableSlides;
    },

    updateSlideInfo: function() {
        this.$slideCount.text(
            `${(this.displayCurrentSlideIndex() || 0) + 1} / ${
                this.playableSlides.length
            }`
        );
    },

    startTimer: function() {
        this.slideSeconds = 0;
        this.$slideTimer.text("00:00:00");
    },

    renderSlides: function() {
        let $scroller = this.$slideList.addEl($.div("scroller"));

        for (let slide of this.player.slides) {
            slide.model.load().then(() => {
                let thumbnail = new PlayerThumbnailView({
                    model: slide.model,
                    slideIndex: this.player.slides.indexOf(slide),
                    player: this.player
                });

                let $thumbnail = thumbnail
                    .render()
                    .$el.addClass("slide-thumbnail");
                $scroller.append($thumbnail);
            });
        }
    }
});
